'use strict';

(() => {
  const template = document.createElement('template');

  template.innerHTML = /* html */ `
      <label style="font-size: 16px;">
        <b><slot></slot></b>
      </label>
    `;

  class DefaultLabel extends HTMLElement {
    #root = null;

    constructor() {
      super();
      this.#root = this.attachShadow({ mode: 'open' });
      this.#root.appendChild(template.content.cloneNode(true));
    }
  }

  customElements.define('default-label', DefaultLabel);
})();
